// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1OXlY","resendInfoText":"OnGoingPaymentBox_resendInfoText__2Utnt"};